export enum Steps {
  Quiz = 'Quiz',
  Anxiety = 'anxietySectionLabel',
  AboutYou = 'aboutYouSectionLabel',
  Sleep = 'sleepSectionLabel',
  SleepAndActivity = 'sleepAndActivitySectionLabel',
  Personalization = 'personalizationSectionLabel',
}
